import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { CoroutineDispatcherizb7p9bijexj as CoroutineDispatcher } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineDispatcher.mjs';
import { HashMap1a0ld5kgwhmhv as HashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/HashMap.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { ExceptionHandlersTree3d2va1xldjhw8 as ExceptionHandlersTree } from '../exceptions/handling.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function exceptionMessage(_this__u8e3s4, exception, metadata) {
  metadata = metadata === VOID ? null : metadata;
  return _this__u8e3s4.exceptionHandlers_1.message_rracq9_k$(_this__u8e3s4, exception, metadata);
}
function handleException(_this__u8e3s4, exception, metadata) {
  metadata = metadata === VOID ? null : metadata;
  return _this__u8e3s4.exceptionHandlers_1.handle_wdrjsg_k$(_this__u8e3s4, exception, metadata);
}
function get_ssrDispatcher(_this__u8e3s4) {
  var tmp = _this__u8e3s4.addons_1.get_wei43m_k$('ssrDispatcher');
  return tmp instanceof CoroutineDispatcher() ? tmp : null;
}
var ChainMapClass;
function ChainMap() {
  if (ChainMapClass === VOID) {
    class $ {
      constructor(parent) {
        parent = parent === VOID ? null : parent;
        this.parent_1 = parent;
        this.local_1 = HashMap().new_kotlin_collections_HashMap_2a5kxx_k$();
        var tmp = this;
        var tmp0_safe_receiver = this.parent_1;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.root_1;
        tmp.root_1 = tmp1_elvis_lhs == null ? this : tmp1_elvis_lhs;
      }
      containsKey_aw81wo_k$(key) {
        var tmp;
        if (this.local_1.containsKey_aw81wo_k$(key)) {
          tmp = true;
        } else {
          var tmp0_safe_receiver = this.parent_1;
          tmp = (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.containsKey_aw81wo_k$(key)) === true;
        }
        return tmp;
      }
      get_wei43m_k$(key) {
        var tmp;
        if (this.local_1.containsKey_aw81wo_k$(key)) {
          tmp = this.local_1.get_wei43m_k$(key);
        } else {
          var tmp0_safe_receiver = this.parent_1;
          tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.get_wei43m_k$(key);
        }
        return tmp;
      }
      set_b9w55f_k$(key, value) {
        // Inline function 'kotlin.collections.set' call
        this.local_1.put_4fpzoq_k$(key, value);
      }
      getOrPut_ppgj9u_k$(key, defaultValue) {
        var tmp0_safe_receiver = this.get_wei43m_k$(key);
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          return tmp0_safe_receiver;
        }
        if (this.containsKey_aw81wo_k$(key)) {
          return this.get_wei43m_k$(key);
        }
        var value = defaultValue();
        // Inline function 'kotlin.collections.set' call
        this.root_1.local_1.put_4fpzoq_k$(key, value);
        return value;
      }
      child_1kc9wc_k$() {
        return new (ChainMap())(this);
      }
    }
    initMetadataForClass($, 'ChainMap', ChainMap);
    ChainMapClass = $;
  }
  return ChainMapClass;
}
var ElementContextCommonCodeClass;
function ElementContextCommonCode() {
  if (ElementContextCommonCodeClass === VOID) {
    class $ {
      constructor(parent) {
        var tmp = this;
        var tmp1_safe_receiver = parent == null ? null : parent.addons_1;
        var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.child_1kc9wc_k$();
        tmp.addons_1 = tmp2_elvis_lhs == null ? new (ChainMap())() : tmp2_elvis_lhs;
        var tmp_0 = this;
        tmp_0.exceptionHandlers_1 = new (ExceptionHandlersTree())(parent == null ? null : parent.exceptionHandlers_1);
      }
    }
    initMetadataForClass($, 'ElementContextCommonCode');
    ElementContextCommonCodeClass = $;
  }
  return ElementContextCommonCodeClass;
}
//region block: exports
export {
  ElementContextCommonCode as ElementContextCommonCode2fsa3eucy75um,
  exceptionMessage as exceptionMessage1cx0ho62128p8,
  handleException as handleException14reyfdad0gfg,
  get_ssrDispatcher as get_ssrDispatcher1kagzmco8c1l4,
};
//endregion

//# sourceMappingURL=ElementContext.mjs.map
